module.exports = __webpack_public_path__ + "static/media/bully_circle.c31d3c6f.png";